export default __webpack_public_path__ + "static/media/Honored Jerkin of the Clans.ff4ad35a.jpg";